module.exports = __webpack_public_path__ + "img/flying-star.fd0204b4.svg";